import { green } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

const GREY = {
  // 0: '#FFFFFF',
  // 100: '#F9FAFB',
  // 200: '#F4F6F8',
  // 300: '#DFE3E8',
  // 400: '#C4CDD5',
  // 500: '#919EAB',
  // 600: '#637381',
  // 700: '#454F5B',
  // 800: '#1c1c1c',
  // 900: '#161C24',
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  1000: '#0f151c',
};

const PRIMARY = {
  lighter: '#ba5aee',
  light: '#e2e1ff',
  main: '#7068FF',
  dark: '#675ffa',
  darker: '#5750d4',
  contrastText: '#ffffff',
};

const SECONDARY = {
  lighter: '#EFD6FF',
  light: '#C684FF',
  main: '#8E33FF',
  dark: '#5119B7',
  darker: '#27097A',
  contrastText: '#FFFFFF',
};

const INFO = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

const PINK = {
  lighter: '#FFE3EB',
  light: '#FFB3C6',
  main: '#FF6690',
  dark: '#CC4D71',
  darker: '#993852',
  contrastText: '#FFFFFF',
};

const SUCCESS = {
  lighter: '#D3FCD2',
  light: '#77ED8B',
  main: '#22C55E',
  dark: '#118D57',
  darker: '#065E49',
  contrastText: '#ffffff',
};

const WARNING = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#FF5630',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#FFFFFF',
};

const BLACK = {
  lighter: '#DDDDDD',
  light: '#CCCCCC',
  main: '#D4D4D4',
  dark: '#B4B4B4',
  darker: '#909090',
  contrastText: '#494848',
};
const GREYS = {
  lighter: '#F9FAFB',
  light: '#F4F6F8',
  main: '#161C24',
  dark: '#637381',
  darker: '#212B36',
  contrastText: '#FFFFFF',
};

const COMMON = {
  common: {
    black: '#000000',
    white: '#FFFFFF',
    purple: '#7068FF',
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  pink: PINK,
  error: ERROR,
  grey: GREY,
  gerys: GREYS,
  black: BLACK,
  divider: alpha(GREY[500], 0.2),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export function palette(mode) {
  const light = {
    ...COMMON,
    mode: 'light',
    text: {
      primary: '#000',
      icon: '#7068FF',
      view: GREY[800],
      secondary: GREY[700],
      third: GREY[700],
      button: '#404040',
      table: GREY[900],
      title: '#070080',
      disabled: GREY[800],
      thank: '#262626',
      mess: '#3f3f3f',
    },
    background: {
      paper: '#FFFFFF',
      card: '#f4f6ff',
      upload: 'ffffff',
      button: '#eaeaea',
      box: '#F6F6F6',
      default: '#f2f6fc',
      border: '#cccccc',
      searchfeild: '#FFFFFF',
      neutral: GREY[200],
    },
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
  };

  const dark = {
    ...COMMON,
    mode: 'dark',
    text: {
      primary: '#fff',
      new: '#F5F5F5',
      view: GREY[400],
      title: GREY[400],
      button: GREY[500],
      thank: GREY[200],
      mess: GREY[500],
      // icon: '#ba5aee',
      // secondary:"#dddddd",
      secondary: GREY[500],
      third: GREY[700],
      table: GREY[400],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[900],
      card: '#0d151e',
      upload: 'f9f9f9',
      searchfeild: '#FFFFFF',
      border: GREY[800],
      button: GREY[800],
      box: GREY[800],
      default: GREY[1000],
      neutral: alpha(GREY[500], 0.12),
    },
    action: {
      ...COMMON.action,
      active: GREY[500],
    },
  };

  return mode === 'light' ? light : dark;
}
// import { alpha } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// // SETUP COLORS

// export const grey = {
//   0: '#FFFFFF',
//   100: '#F9FAFB',
//   200: '#F4F6F8',
//   300: '#DFE3E8',
//   400: '#C4CDD5',
//   500: '#919EAB',
//   600: '#637381',
//   700: '#454F5B',
//   800: '#212B36',
//   900: '#161C24',
// };

// export const primary = {
//   lighter: '#918bf6',
//   light: '#DBD9FC',
//   main: '#7068FF',
//   dark: '#675ffa',
//   darker: '#5750d4',
//   contrastText: '#ffffff',
// };

// export const secondary = {
//   lighter: '#EFD6FF',
//   light: '#C684FF',
//   main: '#8E33FF',
//   dark: '#5119B7',
//   darker: '#27097A',
//   contrastText: '#FFFFFF',
// };

// export const info = {
//   lighter: '#CAFDF5',
//   light: '#61F3F3',
//   main: '#00B8D9',
//   dark: '#006C9C',
//   darker: '#003768',
//   contrastText: '#FFFFFF',
// };

// export const success = {
//   lighter: '#D3FCD2',
//   light: '#77ED8B',
//   main: '#22C55E',
//   dark: '#118D57',
//   darker: '#065E49',
//   contrastText: '#ffffff',
// };

// export const warning = {
//   lighter: '#FFF5CC',
//   light: '#FFD666',
//   main: '#FFAB00',
//   dark: '#B76E00',
//   darker: '#7A4100',
//   contrastText: grey[800],
// };

// export const error = {
//   lighter: '#FFE9D5',
//   light: '#FFAC82',
//   main: '#FF5630',
//   dark: '#B71D18',
//   darker: '#7A0916',
//   contrastText: '#FFFFFF',
// };

// export const common = {
//   black: '#000000',
//   white: '#FFFFFF',
//   purple:'#7068FF'
// };

// export const action = {
//   hover: alpha(grey[500], 0.08),
//   selected: alpha(grey[500], 0.16),
//   disabled: alpha(grey[500], 0.8),
//   disabledBackground: alpha(grey[500], 0.24),
//   focus: alpha(grey[500], 0.24),
//   hoverOpacity: 0.08,
//   disabledOpacity: 0.48,
// };

// const base = {
//   primary,
//   secondary,
//   info,
//   success,
//   warning,
//   error,
//   grey,
//   common,
//   divider: alpha(grey[500], 0.2),
//   action,
// };

// // ----------------------------------------------------------------------

// export function palette(mode) {
//   const light = {
//     ...base,
//     mode: 'light',
//     text: {
//       primary: grey[800],
//       secondary: grey[600],
//       disabled: grey[500],
//     },
//     background: {
//       paper: '#FFFFFF',
//       default: '#F5F5F5',
//       neutral: grey[200],
//     },
//     action: {
//       ...base.action,
//       active: grey[600],
//     },
//   };

//   const dark = {
//     ...base,
//     mode: 'dark',
//     text: {
//       primary: '#FFFFFF',
//       secondary: grey[500],
//       disabled: grey[600],
//     },
//     background: {
//       paper: grey[800],
//       default: grey[900],
//       neutral: alpha(grey[500], 0.12),
//     },
//     action: {
//       ...base.action,
//       active: grey[500],
//     },
//   };

//   return mode === 'light' ? light : dark;
// }
